import React, { Suspense } from 'react';

const withSuspence = (Component) => (
  <Suspense fallback={<div>Loading...</div>}>
    <Component />
  </Suspense>
);

export default withSuspence;
